"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var defaultMessages_1 = require("./constants/defaultMessages");

var errorCodes_1 = __importDefault(require("./constants/errorCodes"));

var errorHandling_1 = require("./errorHandling");

exports.API_MONITORS = {
  SESSION_EXPIRED: 'sessionExpired',
  MISSING_PARAMETER: 'missingParameter',
  INVALID_PARAMETERS: 'invalidParameters',
  USER_ERROR: 'userError',
  RECORD_NOT_UNIQUE: 'recordNotUnique',
  SERVER_ERROR: 'serverError',
  ERROR_USER_UPDATE: 'errorUserUpdate',
  ROUTING_ERROR: 'routingError'
};

var getMonitorParams = function getMonitorParams(response, options) {
  var extraParams = options.getMonitorParams ? options.getMonitorParams() : {};
  return Object.assign({
    originalURL: response.originalUrl || response.config && response.config.url,
    data: response.data,
    requestHeaders: response.config && response.config.headers,
    responseHeaders: response.headers,
    timeout: response.config && response.config.timeout
  }, extraParams);
};

var sessionExpirationMonitor = function sessionExpirationMonitor(rollbarTracker) {
  var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (response.status === 401 && errorHandling_1.existsErrorCodes([errorCodes_1.default.NOT_AUTHORIZED, errorCodes_1.default.AUTH_TOKEN_EXPIRED], response.data)) {
    var parameters = getMonitorParams(response, options);
    rollbarTracker.info('Session expired', parameters);
    options.callback && options.callback();
  }
};

var missingParametersMonitor = function missingParametersMonitor(rollbarTracker) {
  var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (errorHandling_1.existsErrorCode(errorCodes_1.default.PARAM_IS_MISSING, response.data)) {
    var parameters = getMonitorParams(response, options);
    rollbarTracker.error("Missing parameter at: ".concat(parameters.originalURL), parameters);
    options.callback && options.callback();
  }
};

var invalidParametersMonitor = function invalidParametersMonitor(rollbarTracker) {
  var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (errorHandling_1.existsErrorCodes([errorCodes_1.default.INVALID_PARAM, errorCodes_1.default.INVALID_PARAMS], response.data)) {
    var parameters = getMonitorParams(response, options);
    rollbarTracker.error("Invalid parameters at: ".concat(parameters.originalURL), parameters);
    options.callback && options.callback();
  }
};

var userErrorMonitor = function userErrorMonitor(rollbarTracker) {
  var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var parameters = getMonitorParams(response, options);

  if (errorHandling_1.existsErrorCode(errorCodes_1.default.USER_ERROR, response.data) && parameters.originalURL.includes('users/client_auth')) {
    rollbarTracker.error('Error on federated user login', parameters);
    options.callback && options.callback();
  }
};

var recordNotUniqueMonitor = function recordNotUniqueMonitor(rollbarTracker) {
  var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (errorHandling_1.existsErrorCode(errorCodes_1.default.RECORD_NOT_UNIQUE, response.data)) {
    var parameters = getMonitorParams(response, options);
    rollbarTracker.error("Record not unique at: ".concat(parameters.originalURL), parameters);
    options.callback && options.callback();
  }
};

var serviceUnavailableMonitor = function serviceUnavailableMonitor(rollbarTracker) {
  var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (response.status === 503 && errorHandling_1.existsErrorCode(errorCodes_1.default.SERVER_ERROR, response.data)) {
    var parameters = getMonitorParams(response, options);
    rollbarTracker.error("Server error at: ".concat(parameters.originalURL, "."), parameters);
    options.callback && options.callback();
  }
};

var userUpdateErrorMonitor = function userUpdateErrorMonitor(rollbarTracker) {
  var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (response.status === 500 && response.data && response.data.errors && response.data.errors[0] && response.data.errors[0].meta.includes('undefined method')) {
    var parameters = getMonitorParams(response, options);
    rollbarTracker.error("Error on user update at: ".concat(parameters.originalURL), parameters);
    options.callback && options.callback();
  }
};

var routingErrorMonitor = function routingErrorMonitor(rollbarTracker) {
  var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (errorHandling_1.existsErrorCode(errorCodes_1.default.ROUTING_ERROR, response.data)) {
    var parameters = getMonitorParams(response, options);
    rollbarTracker.info("Routing error at:  ".concat(parameters.originalURL), parameters);
    options.callback && options.callback();
  }
};

var monitors = [{
  key: exports.API_MONITORS.SESSION_EXPIRED,
  func: sessionExpirationMonitor
}, {
  key: exports.API_MONITORS.MISSING_PARAMETER,
  func: missingParametersMonitor
}, {
  key: exports.API_MONITORS.INVALID_PARAMETERS,
  func: invalidParametersMonitor
}, {
  key: exports.API_MONITORS.USER_ERROR,
  func: userErrorMonitor
}, {
  key: exports.API_MONITORS.RECORD_NOT_UNIQUE,
  func: recordNotUniqueMonitor
}, {
  key: exports.API_MONITORS.SERVER_ERROR,
  func: serviceUnavailableMonitor
}, {
  key: exports.API_MONITORS.ERROR_USER_UPDATE,
  func: userUpdateErrorMonitor
}, {
  key: exports.API_MONITORS.ROUTING_ERROR,
  func: routingErrorMonitor
}];

exports.createApiMonitors = function (apiInstance, rollbarTracker) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var disableMonitors = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  if (!apiInstance || !rollbarTracker) return console.warn(apiInstance ? defaultMessages_1.DefaultMessages.rollbarInstanceError : defaultMessages_1.DefaultMessages.apiInstanceError);
  monitors.forEach(function (monitor) {
    return !disableMonitors.includes(monitor.key) && apiInstance.addMonitor(function (response) {
      return monitor.func(rollbarTracker, response, options[monitor.key]);
    });
  });
};

exports.addNoCacheHeader = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.assign(Object.assign({}, config), {
    headers: Object.assign(Object.assign({}, config.headers ? config.headers : {}), {
      'Cache-Control': 'no-cache'
    })
  });
};

var API_UTILS = {
  addNoCacheHeader: exports.addNoCacheHeader,
  createApiMonitors: exports.createApiMonitors,
  API_MONITORS: exports.API_MONITORS
};
exports.default = API_UTILS;